export default {
  'menu.companyStaffNewPage': '新增从业人员',
  'menu.companyStaffEditPage': '编辑从业人员',
}